export default __webpack_public_path__ + "static/media/exterior (8).b61294d9.jpg";